import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import NowUiKit from "./plugins/now-ui-kit";
import i18n from './i18n';
import VueGtm from '@gtm-support/vue2-gtm';
import './plugins/smart-app-banner/index.css'
import "./utilities/vee-validate-rules";
import { mapActions, mapGetters, mapState } from "vuex";
import { onMesssageMixin } from '@/mixins'
import { showErrorMessageAlert, getMessageFromAPIError, IsWebView, getCookieTimeExpiration } from "@/utilities/helper"
import { ORDER_TYPE } from "@/utilities/enums"
import { isAndroid, } from "mobile-device-detect";
import { subdomain } from "@/utilities";
//import socialLogin from '@/components/SocialLogin'
//import SocialLogout from '@/components/SocialLogout'


Vue.config.productionTip = false;
Vue.use(NowUiKit);
Vue.use(VueGtm, {
  id: process.env.VUE_APP_GTM, // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryPararms: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}]
  defer: false, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
  enabled: false, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  //debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
});
//Vue.component(socialLogin.name, socialLogin)
//Vue.component(SocialLogout.name, SocialLogout)

async function InitApp() {

  return Promise.resolve();
}
export default InitApp().then(() => {
  new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
    mixins: [onMesssageMixin],
    computed: {
      ...mapGetters('locationStore', ['getTrackingStatus']),
      ...mapGetters('userStore', ['getOneSignalUserId']),
      ...mapState('cartStore', ['postcode']),
      ...mapState('locationStore', ['webAppVersion']),
    },
    methods: {
      ...mapActions('locationStore', [
        "fetchTheme",
        "fetchLocationsByPostCode",
        "getPublicDocsRequest",
        "saveTrackingStatus",
        "saveApplePayAvailibility",
        "saveGooglePayAvailibility",
        "saveChannel",
        "storeSelectedLocation",
        "storeWebAppVersion"
      ]),
      ...mapActions('userStore', ["fetchAuthUser", "saveOneSignalPlayerId", "saveOneSignalUserId"]),
      //---- check the position Object before getting the website data
      fetchThemeConfiguration() {
        this.fetchTheme()
          .then((response) => {
            if (response && response.error) {

              this.$mount("#app");
              showErrorMessageAlert(
                getMessageFromAPIError(response)
              );
              return;
            }
            // fetch the autenticated user
            if (this.isAuthenticated) {
              this.fetchAuthUser()
            }
            if (
              this.locations.length == 1 &&
              this.newCart &&
              this.newCart.orderType == ORDER_TYPE.Delivery.id &&
              this.postcode
            ) {
              this.fetchLocationsByPostCode(this.postcode).then((response) => {
                if (response && response.error) {
                  return;
                }
                this.storeSelectedLocation(response.data.data[0])

                this.$mount("#app");
                if (router.currentRoute.name == "notExist") router.push("/");
              }).catch(() => {
                this.$mount("#app");
                if (router.currentRoute.name == "notExist") router.push("/");
              });
            } else {
              this.$mount("#app");
              if (router.currentRoute.name == "notExist") router.push("/");
            }
          })
          .catch((ex) => {
            console.log(ex)
            this.$mount("#app");
            router.push("/not-exist");
          })
        this.getPublicDocsRequest();
      },
      enableDisableTracking(enabled) {
        this.$gtm.enable(enabled == true);
      }
    },
    watch: {
      getTrackingStatus(newVal) {
        this.enableDisableTracking(newVal)
      }
    },
    created() {
      this.$storage.setOptions({
        prefix: subdomain.get() + "_",
        driver: "local",
        ttl: getCookieTimeExpiration(), //60 * 60 * 24 * 1000
      });
      this.fetchThemeConfiguration();

      if (!IsWebView()) { //|| !isIOS
        this.saveTrackingStatus(true)
      }
      //--- this will be used only if it's w webView
      if (IsWebView()) {

        isAndroid ? document.addEventListener("message", this.messageReceived, false) :
          window.addEventListener("message", this.messageReceived, false);

        if (this.isAuthenticated && this.user && !this.getOneSignalUserId) {
          this.sendMessage({ userId: this.user.id })
        }

        if(!this.webAppVersion || this.webAppVersion != process.env.VUE_APP_VERSION){
          this.sendMessage({ webAppVersion: process.env.VUE_APP_VERSION })
          this.storeWebAppVersion(process.env.VUE_APP_VERSION)
        }

      }else{
        this.storeWebAppVersion(process.env.VUE_APP_VERSION)
      }
      
    },
    mounted() {
      this.enableDisableTracking(this.getTrackingStatus) //-- DON'T FORGET TO set getTrackingStatus to null when activing tracking transparency
    }
  });
});
